import axios from "axios";
import { useState, useEffect } from "react";
import { GetNodeTeam, GetNodeUsers, GetNodeParentUsers, GetNodeParentTeam } from "../model/Team";
import useDeepVinApi from "./useDeepvinApi";

export default function DataProvider(url) {
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const [isFetching, setIsFetching] = useState(false);  

  useEffect( () => {
    const axiosGet = async () => {
      setIsFetching(true);
      setError(null);

      axios.get(url, {withCredentials: true})
      .then(({data}) => {
        setData(data)
        setIsFetching(false)
      })
      .catch(error => {
        console.error("API error: ", error) 
        setIsFetching(false)
        setError(error)
      })
    }

    axiosGet()
  }, [url])

  return data // do NOT use {data}
}

export const useTeamAndUser = (dependencies=[]) => {
  const api = useDeepVinApi()

  const [teamTree, setTeamTree] = useState({})
  const teams = GetNodeTeam(teamTree)
  const users = GetNodeUsers(teamTree)

  useEffect(() => {
    let ignore = false
    api.get(`/api/team/tree`)
    .then(({data}) => {
      if (!ignore) setTeamTree(data)
    })
    .catch(error => console.error("API error: ", error))
    return () => {
      ignore = true
    }
  }, dependencies)
  
  return [teams, users]
}

// TODO active
export const useActiveTemplate = (name) => {
  const api = useDeepVinApi()
  const [template, setTemplate] = useState([])

  useEffect(() => {
    let ignore = false
    api.get(`/api/template/`)
    .then(({data}) => {
      if (!ignore) setTemplate(data.find(t => t.Name === name))
    })
    .catch(error => console.error("API error: ", error))
    return () => {
      ignore = true
    }
  }, [])
  
  return template
}

// Returning teams (including parent->grandparent team(s)) and uses in these teams
export const useTeamAndAllUsers = () => {
  const api = useDeepVinApi()

//  const [parentTree, setParentTree] = useState({})
  const [users, setUsers] = useState([])
  const [teams, setTeams] = useState([])
    
  useEffect(() => {
    let ignore = false
    api.get(`/api/team/parenttree`)
    .then(({data}) => {
      if (!ignore) {
//        setParentTree(data)
        const tusers = GetNodeUsers(data)
        const pusers = GetNodeParentUsers(data.Parent)
        setUsers(pusers ? [...tusers, ...pusers] : tusers)

        const cteams = GetNodeTeam(data)
        const pteams = GetNodeParentTeam(data.Parent)
        setTeams(pteams ? [...cteams, ...pteams] : cteams)

      }
    })
    .catch(error => console.error("API error: ", error))
    return () => {
      ignore = true
    }
  }, [])

  return [teams, users] 
}

export const useDevices = () => {
  const api = useDeepVinApi()
  const [devices, setDevices] = useState([])

  useEffect(() => {
    let ignore = false
    api.get(`/api/device/self`)
    .then(({data}) => {
      if (!ignore) {
        setDevices(data)
      }
    })
    .catch(error => console.error("API error: ", error))
    return () => {
      ignore = true
    }
  }, [])

  return devices
}

export const useReports = () => {
  const api = useDeepVinApi()
  const [reports, setReports] = useState([])

  useEffect(() => {
    let ignore = false
    api.get(`/api/report/self`)
    .then(({data}) => {
      if (!ignore) {
        setReports(data)
      }
    })
    .catch(error => console.error("API error: ", error))
    return () => {
      ignore = true
    }
  }, [])

  return reports
}

export const useArchives = () => {
  const api = useDeepVinApi()
  const [archives, setArchives] = useState([])

  useEffect(() => {
    let ignore = false
    api.get(`/api/archive/`)
    .then(({data}) => { // array of {Archive, NumVids, NumCases}
      if (!ignore) {
        setArchives(data.sort((a,b)=>a.Archive.ID-b.Archive.ID))
      }
    })
    .catch(error => console.error("API error: ", error))
    return () => {
      ignore = true
    }
  }, [])

  return archives
}
